import { combineReducers } from 'redux';
import { some } from './mock/some';

const getGames = (resp) => (Array.isArray(resp?.games) ? resp.games : []);

const getStartedGames = (games) => games.filter(({ started }) => started);

const all = (state = some, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return getGames(action.resp);
    default:
      return state;
  }
};

const noGamesStarted = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED': {
      const games = getGames(action.resp);
      return getStartedGames(games).length === 0;
    }
    default:
      return state;
  }
};

const allGamesStarted = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED': {
      const games = getGames(action.resp);
      return games.length > 0 && getStartedGames(games).length === games.length;
    }
    default:
      return state;
  }
};

const hasGamesToday = (state = true, action) => {
  switch (action.type) {
    case 'SET_NO_CONTEST_TODAY':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  all,
  noGamesStarted,
  allGamesStarted,
  hasGamesToday,
});
